<template>
  <div class="container">
    <!-- 选项 -->
    <div class="option-box" v-for="(option, index) in optionList" :key="index">
      <p class="title">{{ option.name }}</p>
      <div class="item-box">
        <div :class="item.value == selectedValues[index] ? 'option-item selected': 'option-item'" v-for="(item, idx) in option.values" :key="idx" @click="onTapOptionItem(index, item.value)">
          <p :class="item.value == selectedValues[index] ? 'name selected-name': 'name'">{{ item.name }}</p>
        </div>
      </div>
    </div>
    <!-- 确定/重置 只有多组option时才出现-->
    <div class="confirm-box" v-if="optionList.length > 1">
      <div class="reset" @click="onTapReset">
        <p class="title">重置</p>
      </div>
      <div class="confirm" @click="onConfirm">
        <p class="title">确定</p>
      </div>
    </div>
    <!-- 关闭 -->
    <div class="close-box" @click="onClose">
      <img src="../../../assets/common/arrow_down@2x.png"
              alt
              class="arrow-img" />
    </div>
  </div>
</template>

<script>
    export default {
        name: 'option-picker',
        props: {
          optionList: {
            type: Array,
            default:() => {
              return [];
            }
          }
        },
        data () {
            return {
              selectedValues: this.buildSelectedValues(this.optionList)
            }
        },
        methods: {
          // 点击选项
          onTapOptionItem(optionIndex, value){
            this.$set(this.selectedValues, optionIndex, value)
            console.log(this.selectedValues)
            if (this.optionList.length <= 1) {
              // 单组选项-直接关闭弹窗
              this.onConfirm()
            }
          },
          // 构建初始化已选项
          buildSelectedValues(optionList) {
            var selectedValues = []
            for (var i = 0; i < optionList.length; i++) {
              selectedValues.push(optionList[i].selectedValue)
            }
            return selectedValues
          },
          // 点击重置
          onTapReset() {
            var selectedValues = []
            for (var i = 0; i < this.optionList.length; i++) {
              // 默认选首个
              selectedValues.push(this.optionList[i].values[0].value)
            }
            console.log('selected values = ',selectedValues)
            this.selectedValues = selectedValues
          },
          // 点击确定
          onConfirm() {
            for (let index = 0; index < this.optionList.length; index++) {
              const option = this.optionList[index];
              option.selectedValue = this.selectedValues[index];
            }
            this.$emit('onConfirm')
          },
          // 点击关闭
          onClose() {
            this.$emit('onClose')
          }
        }

    }
</script>
<style scoped lang="less">
@vv: 3.75vw;
  .container {
    padding-top: 18/@vv;
    display: flex;
    flex-direction: column;
    .option-box {
      padding-left: 20/@vv;
      padding-right: 20/@vv;
      padding-bottom: 24/@vv;
      margin-bottom: 24/@vv;
      .title {
        font-size: 16 /@vv;
        font-weight: 500;
        color: #171a1d;
        line-height: 22 /@vv;
        margin-bottom: 8/@vv;
      }
      .item-box {
        display: grid;
        grid-template-columns: 102/@vv 102/@vv 102/@vv;
        row-gap: 12/@vv;
        column-gap: 14/@vv;
        .option-item {
          height: 32/@vv;
          width: 102/@vv;
          border-radius: 2/@vv;
          background-color: #ffffff;
          border: 0.5/@vv solid #c8c9cc;
          display: flex;
          align-items: center;
          justify-content: center;
          .name {
            font-size: 14/@vv;
            font-weight: 500;
            color: #54565c;
          }
          .selected-name {
            color: #ffffff;
            font-weight: 400;
          }
        }
        .selected {
          background-color: #36b374;
          border: 0.5/@vv solid #36b374;
        }
      }
    }
    .confirm-box {
      display: flex;
      margin-top: 8/@vv;
      padding-top: 8/@vv;
      padding-left: 20/@vv;
      padding-right: 20/@vv;
      padding-bottom: 24/@vv;
      background: #FFFFFF;
      box-shadow: 0 0 16px 0 #0000000d;
      .reset {
        width: 96/@vv;
        height: 40/@vv;
        border: 1px solid #36b374;
        border-radius: 4/@vv;
        display: flex;
        justify-content: center;
        align-items: center;
        margin-right: 8/@vv;
        .title {
          font-size: 16/@vv;
          font-weight: 500;
          color: #36b374;
        }
      }
      .confirm {
        flex:1;
        height: 40/@vv;
        background-color: #36b374;
        border-radius: 4/@vv;
        display: flex;
        justify-content: center;
        align-items: center;
        .title {
          font-size: 16/@vv;
          font-weight: 500;
          color: #ffffff;
        }
      }
    }
    .close-box {
      position: absolute;
      right: 16/@vv;
      top: 16/@vv;
      width: 20/@vv;
      height: 20/@vv;
      display: flex;
      justify-content: center;
      align-items: center;
      .arrow-img {
        width: 16/@vv;
        height: 16/@vv;
      }
    }
  }
</style>
